import { Text } from "@/components/ui/baseUi/text"
import { withForm } from "@/components/ui/forms/hooks/useFormHook"
import { coachFormDataDefaultValues } from "@/modules/coach/types/coachFormTypes"
import { word } from "@/modules/core/utils/i18n"

const DESCRIPTION_MAX_LENGTH = 5000

export const CoachCreationAboutStep = withForm({
  defaultValues: coachFormDataDefaultValues,
  render: function CoachCreationAboutStepInner({ form }) {
    return (
      <div className="flex flex-col gap-6">
        <div className="flex flex-col">
          <Text fontStyle="HM" className="font-bold text-textOnSurface-default">
            {word("coach.onboarding.about.title")}
          </Text>
          <Text fontStyle="BM" className="font-semibold text-textOnSurface-muted">
            {word("coach.onboarding.about.subtitle")}
          </Text>
        </div>

        <form.AppField name="description">
          {(field) => (
            <field.Field>
              <field.Label fontStyle="LM" className="gap-1 text-textOnSurface-muted uppercase">
                {word("coach.admin.vitrine.about.description")}
                <field.Label fontStyle="LM" className="text-feedback-negative-intense">
                  *
                </field.Label>
              </field.Label>
              <field.Content>
                <field.Textarea
                  rows={6}
                  maxLength={DESCRIPTION_MAX_LENGTH}
                  placeholder={word("coach.admin.vitrine.about.description_hint")}
                />
                <div className="flex justify-end">
                  <Text fontStyle="LS" className="text-textOnSurface-muted">
                    {field.state.value.length}/{DESCRIPTION_MAX_LENGTH}
                  </Text>
                </div>
                <field.Message />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <form.AppField name="formation">
          {(field) => (
            <field.Field>
              <field.Label fontStyle="LM" className="text-textOnSurface-muted uppercase">
                {word("coach.admin.vitrine.about.formation")}
              </field.Label>
              <field.Content>
                <field.Input placeholder={word("coach.admin.vitrine.about.formation_placeholder")} />
                <field.Message />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {(["other1", "other2", "other3"] as const).map((name) => (
            <form.AppField key={name} name={name}>
              {(field) => (
                <field.Field>
                  <field.Content>
                    <field.Input placeholder={word(`coach.admin.vitrine.about.${name}`)} />
                    <field.Message />
                  </field.Content>
                </field.Field>
              )}
            </form.AppField>
          ))}
        </div>
      </div>
    )
  },
})
